/* eslint-disable */
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { DateRangePicker } from 'react-date-range';

class DatePicker extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      display: false,
      focusedDateInput: null,
      startDate: new Date(),
      endDate: new Date(),
    };
  }

  componentDidMount() {
    const { id } = this.props;
    document.addEventListener('click', (e) => {
      const datePickerEl = document.getElementById(id);
      const targetEl = e.target;
      if (datePickerEl && datePickerEl.contains(targetEl)) {
        // don't change the display to false since we're 
        // inside of the date picker element
        return;
      }
      // we've gotten to an element outside of the date picker
      // so we should close the date picker
      this.setState({ display: false });
    });
  }

  handleDateFocusChange = (focusedDateInput) => {
    this.setState({ focusedDateInput });
  };

  handleSearchDatesChange = ({ startDate, endDate }) => {
    const { setSearchTerm, startProp, endProp } = this.props;

    if (startDate) {
      setSearchTerm(startProp, moment(startDate).startOf('day').toISOString());
      console.log('sd');
    } else {
      setSearchTerm(startProp, null);
    }

    if (endDate) {
      setSearchTerm(endProp, moment(endDate).endOf('day').toISOString());
      console.log('ed');
    } else {
      setSearchTerm(endProp, null);
    }
  };

  handleRangeCheck = () => false;

  renderDisplayDates = (startDate, endDate) => {
    // Fmtd = Formatted
    let startFmtd = 'Start Date';
    let endFmtd = 'End Date';
    if (startDate) {
      startFmtd = moment(startDate).format('MM/DD/YYYY');
    }
    if (endDate) {
      endFmtd = moment(endDate).format('MM/DD/YYYY');
    }
    return `${startFmtd} - ${endFmtd}`;
  };

  handleClearClick = (e) => {
    e.preventDefault();
    this.handleSearchDatesChange({
      startDate: null,
      endDate: null,
    });
    this.setState({
      startDate: new Date(),
      endDate: new Date(),
    });
  }

  render() {
    const { focusedDateInput } = this.state;
    const {
      id,
      startProp,
      endProp,
      startDate,
      endDate,
    } = this.props;
    const { display } = this.state;

    const datePickerRange = {
      startDate:  startDate ? moment(startDate).toDate() : this.state.startDate,
      endDate: endDate ? moment(endDate).toDate() : this.state.endDate,
      key: 'selection',
    }

    return (
      <div id={id}>
        <div className="input-group">
          <input
            className="form-control form-control-sm"
            onFocus={() => this.setState({ display: true })}
            value={this.renderDisplayDates(startDate, endDate)}
          />
          <button
            className="btn btn-outline-danger"
            onClick={(e) => this.handleClearClick(e)}
          >
            X
          </button>
        </div>
        <div
          className="record-date-picker-box"
          style={{ display: display ? 'block' : 'none' }}
        >
          <DateRangePicker
            onChange={(d) => {
              this.handleSearchDatesChange(d.selection);
              this.setState({
                startDate: d.selection.startDate,
                endDate: d.selection.endDate,
              });
            }}
            showSelectionPreview
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={[datePickerRange]}
            direction="horizontal"
          />
        </div>
      </div>
    );
  }
}

DatePicker.defaultProps = {
  startProp: 'stEnrollmentStartDate',
  endProp: 'stEnrollmentEndDate',
};

const mapStateToProps = (state, props) => ({
  startDate: state.records[props.startProp],
  endDate: state.records[props.endProp],
});

const mapDispatchToProps = {
  setSearchTerm: (name, value) => ({ type: 'SET_SEARCH_TERM', name, value }),
};

export default connect(mapStateToProps, mapDispatchToProps)(DatePicker);
